module.exports = __webpack_public_path__ + "static/media/13.c64b4248.jpg";